function OffenderPhoto() {
    "use strict";
    this.__type = 'OffenderPhoto:www.veritracks.com';
    this.Id = -1;

    this.EnrolleeId = -1;
    this.IsActive = 1;
    this.PhotoUri = '';
    this.PhotoOrderNo = 0;
    this.PhotoDescription = 'Default';
    this.PhotoTypeId = 1;
    this.AlcoholImageId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderPhoto;
}